import { Navigate } from "react-router-dom";
import SchoolDataComponent from "./components/schooldata";
import LogInPageComponent from "./components/LogInPage";
import OrderDetailsComponent from "./components/opp/OrderDetails";
import OrderCreationComponent from "./components/opp/OrderCreation";
import OrderListing from "./components/opp/OrderListing";
import MapComponent from "./components/map/Map";
import TriggerOneClick from "./components/oneclick/TriggerOneClick";
import InstallationReportStandalone from "./components/opp/ReportGenerator";
import ReportGeneratorTest from "./components/opp/ReportGeneratorTest";
import ReportViewer from "./components/opp/ReportViewer";

export const PublicRoute = ({
  component: Component,
  isAuthenticated,
  ...rest
}) => {
  if (isAuthenticated) {
    return <Navigate to="/schooldata" />;
  }

  return <Component {...rest} />;
};

export const PrivateRoute = ({
  component: Component,
  isAuthenticated,
  ...rest
}) => {
  return isAuthenticated ? <Component {...rest} /> : <Navigate to="/" />;
};

export const routes = [
  {
    path: "/",
    component: LogInPageComponent,
    privateRoute: false,
  },
  {
    path: "/schooldata/:schoolId?",
    component: SchoolDataComponent,
    privateRoute: true,
  },
  {
    path: "/teacherdata/:schoolId?",
    component: SchoolDataComponent,
    privateRoute: true,
  },
  {
    path: "/opp/create",
    component: OrderCreationComponent,
    privateRoute: true,
  },
  {
    path: "/opp/:orderId?",
    component: OrderDetailsComponent,
    privateRoute: true,
  },
  {
    path: "/schooldata/map",
    component: MapComponent,
    privateRoute: true,
  },
  {
    path: "/opp/orders",
    component: OrderListing,
    privateRoute: true,
  },
  {
    path: "/triggerOneClick",
    component: TriggerOneClick,
    privateRoute: true,
  },
  {
    path: "/installation-report-test",
    component: ReportGeneratorTest,
    privateRoute: true,
  },
  {
    path: "/installation-report",
    component: InstallationReportStandalone,
    privateRoute: false,
    openRoute: true,
  },
  {
    path: "/report-view/:reportId",
    component: ReportViewer,
    privateRoute: false,
    openRoute: true,
  },
];
